export default __webpack_public_path__ + "static/media/icon-orders.1663ea3e.svg";